import { getViewportHeight, getViewportWidth } from '../getViewportDimensions';

/**
 * Функция возвращает расстояние от центра переданного элемента до точки на экране
 * Точка экрана задается в относительном формате: 0 - начало, 1 - конец (по х и y отдельно)
 * @example
 * // Вернет расстояние от центра el до точки вьюпорта: центр по горизонтали и верхний край по вертикали
 * distanceBetweenElAndScreenPoint(el, {x: 0.5, y: 0.2});
 * */
export const distanceBetweenElAndScreenPoint = (el: HTMLElement, screenPointPercent: IPoint): number => {
  const rect = el.getBoundingClientRect();

  const windowHeight = getViewportHeight();
  const windowWidth = getViewportWidth();

  const elementCenter = {
    x: rect.x + rect.width / 2,
    y: rect.y + rect.height / 2,
  };

  const screenPoint = {
    x: windowWidth * screenPointPercent.x,
    y: windowHeight * screenPointPercent.y,
  };

  return distanceBetweenTwoPoints(screenPoint, elementCenter);
};

export interface IPoint {
  x: number;
  y: number;
}

export function distanceBetweenTwoPoints(p1: IPoint, p2: IPoint): number {
  const a = p1.x - p2.x;
  const b = p1.y - p2.y;

  return Math.sqrt(a * a + b * b);
}
